import { SITE } from "@/data/site";
import { Butterfly } from "@/components/site/Logo";
import { Linkedin, Facebook, Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative py-16 border-t border-[#0A0A14]/12" data-testid="footer">
      <div className="container-mit grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 mb-2">
            <Butterfly size={56} />
            <div className="font-display text-3xl text-[#0A0A14]">Metamorphosis</div>
          </div>
          <p className="text-[11px] tracking-[0.3em] text-[#A4801C] mt-2">SINCE 2012 · PAN INDIA</p>
          <p className="text-[#0A0A14]/65 mt-6 max-w-md text-sm leading-relaxed">
            {SITE.tagline}. Institute of Transformation for individuals, teams and enterprises.
          </p>
        </div>
        <div>
          <p className="text-[10px] tracking-[0.3em] text-[#0A0A14]/50 uppercase mb-4">Contact</p>
          <ul className="space-y-2 text-[#0A0A14]/70 text-sm">
            <li>{SITE.emails.info}</li>
            <li>{SITE.phones.service}</li>
          </ul>
        </div>
        <div>
          <p className="text-[10px] tracking-[0.3em] text-[#0A0A14]/50 uppercase mb-4">Follow</p>
          <div className="flex items-center gap-4">
            <a href={SITE.social.linkedin} target="_blank" rel="noreferrer" className="text-[#0A0A14]/65 hover:text-[#4B1EAD]" data-testid="social-linkedin"><Linkedin size={18} /></a>
            <a href={SITE.social.facebook} target="_blank" rel="noreferrer" className="text-[#0A0A14]/65 hover:text-[#4B1EAD]" data-testid="social-facebook"><Facebook size={18} /></a>
            <a href={SITE.social.instagram} target="_blank" rel="noreferrer" className="text-[#0A0A14]/65 hover:text-[#4B1EAD]" data-testid="social-instagram"><Instagram size={18} /></a>
            <a href={SITE.social.youtube} target="_blank" rel="noreferrer" className="text-[#0A0A14]/65 hover:text-[#4B1EAD]" data-testid="social-youtube"><Youtube size={18} /></a>
          </div>
        </div>
      </div>
      <div className="container-mit mt-12 pt-6 border-t border-[#0A0A14]/12 flex flex-col md:flex-row justify-between gap-3 text-[11px] tracking-[0.2em] text-[#0A0A14]/50 uppercase">
        <p>© {new Date().getFullYear()} Metamorphosis Institute of Transformation LLP</p>
        <p>Designed for the Breakthrough Innovators.</p>
      </div>
    </footer>
  );
}
